var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPendingRequest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 65 65",
    viewBox: "0 0 65 65",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 32.5,
    fill: "#eaebf0",
    r: 32
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m30.5 8.5h4v14.6h-4z",
    fill: "#b3e3a5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35.3 23.8h-5.5v-16.1h5.5zm-4-1.5h2.5v-13.1h-2.5z",
    fill: "#47769d"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m30.5 41.9h4v14.6h-4z",
    fill: "#b4dbfd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35.3 57.2h-5.5v-16h5.5zm-4-1.5h2.5v-13h-2.5z",
    fill: "#47769d"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m41.9 30.5h14.6v4h-14.6z",
    fill: "#ff6877"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m57.2 35.2h-16v-5.5h16.1v5.5zm-14.5-1.5h13.1v-2.5h-13.1z",
    fill: "#47769d"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m8.5 30.5h14.6v4h-14.6z",
    fill: "#e2f3ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.8 35.2h-16.1v-5.5h16.1zm-14.6-1.5h13.1v-2.5h-13.1z",
    fill: "#47769d"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m37 18.7h14.6v4h-14.6z",
    fill: "#f5fdff",
    transform: "matrix(.707 -.707 .707 .707 -1.649 37.396)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m40.6 28.3-3.9-3.9 11.4-11.4 3.9 3.9zm-1.8-3.9 1.8 1.8 9.3-9.3-1.8-1.8z",
    fill: "#47769d"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m13.4 42.3h14.6v4h-14.6z",
    fill: "#cccbdd",
    transform: "matrix(.707 -.707 .707 .707 -25.275 27.612)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.9 51.9-3.9-3.9 11.4-11.4 3.9 3.9zm-1.7-3.8 1.8 1.8 9.3-9.3-1.8-1.8z",
    fill: "#47769d"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m42.3 37h4v14.6h-4z",
    fill: "#ffd087",
    transform: "matrix(.707 -.707 .707 .707 -18.355 44.313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m48.1 51.9-11.4-11.3 3.9-3.9 11.4 11.4zm-9.3-11.3 9.3 9.3 1.8-1.8-9.3-9.3z",
    fill: "#47769d"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingRequest);
export default __webpack_public_path__ + "static/media/pending-request.6f6c85af5a272ec081c76d73381305d3.svg";
export { ForwardRef as ReactComponent };